import { prefetchTopPayouts } from '@/api/games/queries/useTopPayouts/prefetch';
import HomeComponent from '@/components/Home/V3';
import { Language } from '@/enums/language';
import { GetServerSidePropsResultWithMetadataAndServerState } from '@/interfaces/pages/getServerSidePropsResultWithMetadataAndDehydratedState';
import { SSRCookies } from '@/interfaces/ssr-cookies.interface';
import { generateCasinoMetadata } from '@/lib/metadata';
import { mainPrefetchs } from '@/lib/prefetch';

import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetServerSidePropsContext } from 'next';

export default function HomePage() {
  return <HomeComponent />;
}

export async function getServerSideProps({
  locale,
  req,
}: GetServerSidePropsContext): Promise<GetServerSidePropsResultWithMetadataAndServerState> {
  const queryClient = new QueryClient();
  const metadata = await generateCasinoMetadata({
    lang: locale as Language,
    path: '/',
  });

  await Promise.all([
    prefetchTopPayouts(queryClient, {} as SSRCookies),
    mainPrefetchs({
      queryClient,
      req,
    }),
  ]);

  return {
    props: {
      metadata: JSON.stringify(metadata),
      dehydratedState: dehydrate(queryClient),
    },
  };
}
